<template>
  <div class="container-list">
    <template v-if="videoInterviewInfo">
    <!-- 入室前 -->
    <template v-if="!isStart">
      <StartView
        :isBlind="isBlind"
        :isMute="isMute"
        :inputs="inputs"
        :videoInterviewInfo="videoInterviewInfo"
        :memberNum="memberNum"
        :getVolume="getVolume"
        @startConnect="startConnect"
        @setAudioSwitch="setAudioSwitch"
        @setVideoSwitch="setVideoSwitch"
      />
    </template>
    <div class="web-video-view" :class="{'video-flex': isWidthWide()}" :style="getChatStatus()">
      <video @loadeddata="playVideo" id="local_video_share" class="off-video" muted playsinline autoplay></video>
      <template v-if="isWidthWide()">
        <!-- PC画面 -->
        <div :style="getStyleVideo(remoteStreams.length + 1, -1, -1)"
          :class="{'big-video': bigId === -1,
            'big-video-side': bigId !== -1
              && bigId !== null
              && isBigIndex(),
            'normal-video': bigId===null,
            'off-video': !isStart}"
          @mouseenter="onMouseStream(-1)"
          @mouseleave="outMouseStream(-1)"
          @click="bigVideo(-1); assignBigIndex(-1)">
          <video @loadeddata="playVideo"
            id="local_video"
            class="video-size-remote"
            muted
            playsinline
            autoplay></video>
          <div class="mouse-over-blind" v-if="remoteStreams.length!=0 && mouseOverIndex==-1"></div>
          <div class="video-user-name">
            {{userName + (isMute
              ? '(ミュート)'
              : '')}}
          </div>
          <div class="video-volume" v-if="!isMute">
            <meter high="0.25" max="1" :value="getVolume"></meter>
            <div class="circle_volume"/>
            <div class="volume_line_fix"/>
          </div>
          <img src="@/assets/template/videoview-pin.png"
            class="mouse-over-pin"
            v-if="remoteStreams.length!=0 && mouseOverIndex==-1 && bigId!=-1">
          <img src="@/assets/template/videoview-pin-n.png"
            class="mouse-over-pin"
            v-if="remoteStreams.length!=0 && mouseOverIndex==-1 && bigId==-1">
        </div>
        <div v-for="(stream, i) in remoteStreams" :key="i"
          :style="getStyleVideo(remoteStreams.length + 1, stream.id, i)"
          :class="{'big-video': bigId === stream.id,
            'big-video-side': bigId !== stream.id
              && bigId !== null
              && (isBigIndex() || bigId === -1),
            'normal-video': bigId===null
              || (!isBigIndex() && bigId !== -1)
                }"
          @mouseenter="onMouseStream(i)"
          @mouseleave="outMouseStream(i)"
          @click="bigVideo(stream.id); assignBigIndex(i)">
          <video @loadeddata="playVideo"
            :srcObject.prop="stream"
            class="video-size-remote"
            :class="{'is-not-share': !roomMembers[stream.peerId].share}"
            autoplay
            playsinline></video>
          <div class="video-volume" v-if="!roomMembers[stream.peerId].mute">
            <meter high="0.25" max="1" :value="roomMembers[stream.peerId].volume"></meter>
            <div class="circle_volume"/>
            <div class="volume_line_fix"/>
          </div>
          <div class="mouse-over-blind" v-if="mouseOverIndex==i"></div>
          <div class="video-user-name">
            {{roomMembers[stream.peerId].name + (roomMembers[stream.peerId].mute && !roomMembers[stream.peerId].share
              ? '(ミュート)'
              : '')}}
            <div v-for="value,peerId in unRead.by_person">
              <div class="unread" v-if="stream.peerId == peerId && value> 0">
                <p>{{value< 10 ? value : '9+'}}</p>
              </div>
            </div>
          </div>
          <img src="@/assets/template/videoview-pin.png" class="mouse-over-pin"
            v-if="mouseOverIndex==i && bigId!=stream.id">
          <img src="@/assets/template/videoview-pin-n.png" class="mouse-over-pin"
            v-if="mouseOverIndex==i && bigId==stream.id">
        </div>
      </template>
      <template v-else>
        <!-- スマホ 画面 -->
        <div style="height: 33vh;" v-if="bigIndex !== null"><!-- 固定時の余白用 --></div>
        <div
          :class="{
            'big-video-top'     : bigIndex === -1,
            'big-video-bottom'  : bigIndex !== -1,
            'off-video'     : !isStart
          }"
          @click="bigVideo(-1);assignBigIndex(-1)">
          <video
            @loadeddata="playVideo"
            id="local_video"
            class="video-size-remote"
            muted
            playsinline
            autoplay>
          </video>
          <div class="video-user-name">
            {{userName + (isMute ? '(ミュート)' : '')}}
          </div>
          <div class="video-volume" v-if="!isMute">
            <meter high="0.25" max="1" :value="getVolume"></meter>
            <div class="circle_volume"/>
            <div class="volume_line_fix"/>
          </div>
          <img src="@/assets/template/videoview-pin-n.png" class="video-fixed-pin"
            v-if="bigIndex==-1">
        </div>
        <div
          v-for="(stream, i) in remoteStreams" :key="i"
          :class="{
            'big-video-top'     : bigIndex === i,
            'big-video-bottom'  : bigIndex !== i,
          }"
          @click="bigVideo(i);assignBigIndex(i)">
          <video
            @loadeddata="playVideo"
            :srcObject.prop="stream"
            class="video-size-remote"
            :class="{
              'is-not-share': !roomMembers[stream.peerId].share
            }"
            autoplay
            playsinline>
          </video>
          <div class="video-volume" v-if="!roomMembers[stream.peerId].mute">
            <meter high="0.25" max="1" :value="roomMembers[stream.peerId].volume"></meter>
            <div class="circle_volume"/>
            <div class="volume_line_fix"/>
          </div>
          <div class="video-user-name">
            {{roomMembers[stream.peerId].name + (roomMembers[stream.peerId].mute && !roomMembers[stream.peerId].share ? '(ミュート)' : '')}}
            <div v-for="(value, peerId) in unRead.by_person" :key="peerId">
              <div class="unread" v-if="stream.peerId == peerId && value> 0">
                <p>{{value< 10 ? value : '9+'}}</p>
              </div>
            </div>
          </div>
          <img src="@/assets/template/videoview-pin-n.png" class="video-fixed-pin"
            v-if="bigIndex==i">
        </div>
      </template>
      <!-- ボタンメニュー -->
      <MenuBar
        :isBlind="isBlind"
        :isMute="isMute"
        :isShare="isShare"
        :isShowChat="isShowChat"
        :unRead="unRead"
        @shareScreen="shareScreen"
        @endConnect="endConnect"
        @setAudioSwitch="setAudioSwitch"
        @setVideoSwitch="setVideoSwitch"
        @changeChatModal="changeChatModal"
        v-if="isStart"
      />
    </div>
      <transition name="chat">
        <ModalChat
          @cancel="changeChatModal"
          @sendMessage="sendMessage"
          @unReadChange="unReadChange"
          :inputs="inputs"
          :unRead="unRead"
          :chatMessages="chatMessages"
          v-if="isShowChat"
        />
      </transition>
    </template>
    <template v-else>
      <div>
        <span class="mdi mdi-loading mdi-spin"></span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StartView from "@/components/VideoInterview/organisms/StartView"
import ModalChat from "@/components/VideoInterview/organisms/ModalChat"
import MenuBar from "@/components/VideoInterview/organisms/MenuBar"
import Peer from 'skyway-js'
export default {
  components: {
    StartView,
    ModalChat,
    MenuBar
  },
  data () {
    return {
      isStart: false,
      isShare: false,
      isShowChat: false,
      bigId: null,
      bigIndex: null,
      inputs: {
        inputAikotoba: null,
        inputName: null,
      },
      mouseOverIndex: null,
      unRead: {
        index: -1,
        date: null,
        count: 0
      }
    }
  },
  computed: {
    ...mapState('auth', ['user', 'videoInterviewInfo']),
    ...mapState('webRTC', ['remoteStreams', 'memberNum', 'roomMembers', 'isMute', 'isBlind', 'waitingPeer', 'waitingRoom', 'userName', 'getVolume', 'chatMessages', 'peerId', 'requestData']),
  },
  mounted () {
    let name = localStorage.getItem('_name')
    if (name) {
      this.inputs.inputName = name
    }
    this.$store.dispatch('auth/getVideoInterviewInfo', this.$route.params.room_name)
    this.$nextTick(() => {
      this.setupLocalVideo()
    })
  },
  watch: {
    // 承認
    requestData () {
      this.displayJoinRequest()
    },
    isStart () {
      this.displayJoinRequest()
    },
    remoteStreams () {
      if (!this.remoteStreams.map((st) => st.id).includes(this.bigId)) this.bigId = null
      if (this.remoteStreams.length == 0) this.bigId = null
    },
    chatMessages () {
      if (this.unRead.date) {
        let index = this.$_.findIndex(
          this.chatMessages,
          ((m) => { return new Date(m.createdAt) > new Date(this.unRead.date) })
        )
      let count = this.chatMessages.length - index
      let unread_messages = this.chatMessages.slice(-count)
      let by_person = {}
        for (const elem of unread_messages) {
          let temp_key = elem['peerId']
          if(by_person[temp_key]) {
            by_person[temp_key] +=  1
          } else {
            by_person[temp_key] = 1;
          }
        }
        this.unReadChange({
          index: index,
          count: count,
          date:  null,
          by_person:by_person
        })
      } else {
        let count = this.chatMessages.length
        let unread_messages = this.chatMessages.slice(-count)
        let by_person = {}
          for (const elem of unread_messages) {
            let temp_key = elem['peerId']
            if(by_person[temp_key]) {
              by_person[temp_key] +=  1
            } else {
              by_person[temp_key] = 1;
            }
          }
        this.unReadChange({
          index: 0,
          count: count,
          date:  new Date(this.chatMessages[0].createdAt),
          by_person:by_person
        })
      }
      if (this.chatMessages.slice(-1)[0]['speaker'] == "other"){
        let music = new Audio();
        music.preload = "auto";
        music.src = require('@/assets/template/recieved_message.mp3');
        music.load();
        music.play();
      }
    }
  },
  methods: {
    displayJoinRequest () {
      if (this.$store.getters['auth/isClient'] && this.isStart === true) {
        for (const req of this.requestData) {
          if (!req.flg) {
            let music = new Audio();
            music.preload = "auto";
            music.src = require('@/assets/template/web_meeting_request.mp3');
            music.load();
            music.play();
            let conf = this.$buefy.dialog.confirm({
              message: this.nameInputCheck(req.name) + '様より参加リクエストが送られました。承認しますか？',
              confirmText: 'はい',
              cancelText: 'いいえ',
              canCancel: ['button'],
              onConfirm: () => {
                this.$buefy.toast.open(this.nameInputCheck(req.name) + '様のリクエストを承認いたしました。')
                reqData.flg = true
                this.$store.dispatch('webRTC/setRequestData', reqData)
              },
              onCancel: () => {
                this.$buefy.toast.open(this.nameInputCheck(req.name) + '様のリクエストを否認いたしました。')
                this.$store.dispatch('webRTC/setRequestData', reqData)
              }
            })
            let reqData = this.$_.cloneDeep(req)
            conf()
          }
        }
      }
    },
    nameInputCheck (name) {
      if (name) {
        return name
      } else {
        return '匿名ユーザー'
      }
    },
    setAudioSwitch (flg) {
      this.$store.dispatch('webRTC/setAudioSwitch', flg)
    },
    setVideoSwitch (flg) {
      this.$store.dispatch('webRTC/setVideoSwitch', flg)
    },
    isWidthWide () {
      return window.outerWidth > 600
    },
    getAuth () {
      if (!this.videoInterviewInfo.aikotoba) return false
      else if (!this.inputs.inputAikotoba) return true
      else if (this.inputAikotoba === this.videoInterviewInfo.aikotoba) return false
      else return true
    },
    async playVideo (event) {
      await event.target.play()
    },
    setupLocalVideo () {
      let uriParam = this.$route.params.room_name
      setTimeout (() => {
        // 動画リソースを生成する
        // DOM要素が取得できるまで繰り返す
        var count = 0
        var id = setInterval(() => {
          var localVideo = document.getElementById('pre_local_video')
          if (localVideo) {
            // カメラとマイクを起動してストリームを作成する
            this.$store.dispatch('webRTC/setVideo', {
              room : uriParam,
              video: localVideo,
              connect: false,
            })
            clearInterval(id)
          }
          count++
          if (count == 50) clearInterval(id)
        }, 200)
        // 待機ルームに入る
        this.$store.dispatch('webRTC/waitingConnect')
        var count2 = 0
        var id2 = setInterval(() => {
          if (this.waitingPeer && this.waitingPeer.open && this.waitingRoom) {
            clearInterval(id2)
          } else {
            this.$store.dispatch('webRTC/waitingConnect')
          }
          count2++
          if (count2 == 10) clearInterval(id2)
        }, 1000);
      }, 500)
    },
    startConnect () {
      this.$nextTick(function () {
        let uriParam = this.$route.params.room_name
        this.isStart = true
        let name = this.inputs.inputName
        if (name) {
          localStorage.setItem('_name', this.inputs.inputName)
        } else {
          name = 'No Name'
        }
        setTimeout (() => {
          // 動画リソースを生成する
          var localVideo = document.getElementById('local_video')
          // カメラとマイクを起動してストリームを作成する
          this.$store.dispatch('webRTC/setVideo', {
            room : uriParam,
            video: localVideo,
            connect: true,
            userName: this.inputs.inputName,
            peerId: this.peerId,
          })
        }, 300)
      })
    },
    endConnect () {
      this.isStart = false
      this.setupLocalVideo()
      this.$store.dispatch('webRTC/endCall')
    },
    shareScreen (flg) {
      this.isShare = flg
      if (this.isShare) {
        this.$nextTick(() => {
          let uriParam = this.$route.params.room_name
          setTimeout (() => {
            let localVideo = document.getElementById('local_video_share')
            this.$store.dispatch('webRTC/setVideoShare', {
              room : uriParam,
              video: localVideo
            })
          }, 300)
        })
      } else {
        this.$store.dispatch('webRTC/endCallShare')
      }
    },
    getStyleVideo (len, id, i) {
      if (this.bigId == null || !this.isBigIndex() && this.bigId !== -1) {
        //拡大していない
        let w, h
        switch (len) {
          case 1:
            w = '100%'
            h = '100%'
            break
          case 2:
            w = 'calc(100% / 2)'
            h = '100%'
            break
          case 3:
          case 4:
            w = 'calc(100% / 2)'
            h = 'calc(100% / 2)'
            break
          case 5:
          case 6:
            w = 'calc(100% / 3)'
            h = 'calc(100% / 2)'
            break
          case 7:
          case 8:
          case 9:
            w = 'calc(100% / 3)'
            h = 'calc(100% / 3)'
            break
          case 10:
          case 11:
          case 12:
          default:
            w = 'calc(100% / 4)'
            h = 'calc(100% / 3)'
            break
        }
        return { width: w, height: h }
      } else {
        //拡大している
        if (this.bigId === id) return {}
        if (this.bigIndex === -1) {
          return {'top': (i * 25) + 'vh'}
        } else {
          if (i === -1) return {'top': '0vh'}
          else if (this.bigIndex > i) return {'top': (i * 25) + 25 + 'vh'}
          else return {'top': (i * 25) + 'vh'}
        }
      }
    },
    bigVideo (id) {
      if (this.bigId === id) {
        this.bigId = null
      } else {
        if (this.remoteStreams.length === 0) return
        this.bigId = id
      }
    },
    assignBigIndex (i) {
      if (this.bigIndex === i) {
        this.bigIndex = null
      } else {
        if (this.remoteStreams.length === 0) return
        this.bigIndex = i
      }
    },
    onMouseStream (index) {
      this.mouseOverIndex = index
    },
    outMouseStream (index) {
      if (this.mouseOverIndex == index) this.mouseOverIndex = null
    },
    isBigIndex () {
      return this.remoteStreams.filter(v => v.id === this.bigId).length >= 1
    },
    getChatStatus () {
      if (this.isShowChat) {
        return {
          'width': 'calc(100% - 320px)',
          'height': '100%',
          'position': 'relative',
        }
      } else {
        return {
          'width': '100%',
          'height': '100%',
          'position': 'relative'
        }
      }
    },
    changeChatModal (flg) {
      this.isShowChat = flg
    },
    sendMessage (message) {
      this.$store.dispatch('webRTC/sendMessage', message)
    },
    unReadChange (param) {
      if (param.index != null) {
        this.$set(this.unRead, 'index', param.index)
      }
      if (param.count != null) {
        this.$set(this.unRead, 'count', param.count)
      }
      if (param.date != null) {
        this.$set(this.unRead, 'date', param.date)
      }
      if (param.by_person != null) {
        this.$set(this.unRead, 'by_person', param.by_person)
      }
    },
  },
  beforeDestroy () {
    this.$store.dispatch('webRTC/endCall')
    this.$store.dispatch('webRTC/waitingDisconnect')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container-list {
  height: 100vh;
  width: 100vw;
  position: relative;
  background: #111;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.web-video-view {
  height: 100vh;
  width: 100vw;
  position: relative;
  background: #111;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.video-flex {
  display: flex;
}
.video-size-remote {
  width: 100%;
  height: 100%;
}
#pre_local_video {
  transform: scale(-1, 1);
}
#local_video {
  transform: scale(-1, 1);
}
.is-not-share {
  transform: scale(-1, 1);
}

.big-video {
  position: fixed;
  z-index: 300;
  top : 0px;
  left: 0px;
  width: calc(100% - 320px);
  height: 100vh;
  background: #111;
}
.off-video {
  border: none;
  pointer-events: none;
  display: none;
}
.pre-video {
  height: 300px;
  width: calc(100% - 300px);
}
.normal-video {
  position: relative;
}
.mouse-over-blind {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.3);
}
.mouse-over-pin {
  position: absolute;
  width: 40px;
  height: 40px;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
}
.video-user-name {
  position: absolute;
  text-align: left;
  left:   8px;
  bottom: 8px;
  color: white;
}
.video-volume {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #fff;
}
.circle_volume {
  position: absolute;
  top:   2px;
  left:  -6px;
  width:  36px;
  height: 36px;
  border: solid 10px #fff;
  border-color:   transparent transparent  #fff transparent;
  border-radius: 100px 0px 100px 100px;
}
.volume_line_fix {
  top: 36px;
  left: -12px;
  position: absolute;
  margin-left: 20px;
  width: 8px;
  height: 8px;
  background-color: #fff;
}
meter {
  height: 24px;
  width: 24px;
  transform: rotate(-90deg);
  transition: 0.45s;
}
.big-video-side {
  position: absolute;
  width: 320px;
  height: 25vh;
  margin-left: calc(100% - 320px);
}
.pre-video {
  background: #ccc;
  margin-right: 8px;
}
@media screen and (max-width: 600px) {
  .video-size-remote {
    width: 100% !important;
    height: 100% !important;
  }
}

.big-video-top {
  position: fixed;
  height: 33vh;
  top: 0px;
  z-index: 100;
  background-color: black;
}
.big-video-bottom {
  height: 33vh;
  position: relative;
  background-color: black;
}
.video-fixed-pin {
  position: absolute;
  width: 40px;
  height: 40px;
  bottom: 8px;
  right: 8px;
}

.chat-enter-active, .chat-leave-active {
  position: fixed;
  right: 0;
  transform: translateX(0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.chat-enter, .chat-leave-to {
  transform: translateX(320px);
}
.unread {
  position: absolute;
  top: -32px;
  right: -8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 12.5px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  background: #EE2C98;
}

// safari
::-webkit-full-page-media, :future, :root .circle_volume {
  display: none;
}
::-webkit-full-page-media, :future, :root .volume_line_fix {
  display: none;
}
::-webkit-full-page-media, :future, :root .video-volume {
  padding: 4px 4px 2px 2px;
  border-radius: 2px;
  background: white;
}

// firefox
@-moz-document url-prefix() {
  .circle_volume {
    display: none;
  }
  .volume_line_fix {
    display: none;
  }
  .video-volume {
    padding: 4px 4px 2px 2px;
    border-radius: 2px;
    background: white;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/VideoInterview/VideoInterview.vue